import React, { useState, useEffect, useRef, useCallback } from 'react';
import api from '../utils/api';

function timeAgo(d) {
  const diff = Date.now() - new Date(d).getTime();
  const m = Math.floor(diff / 60000);
  if (m < 1) return 'just now';
  if (m < 60) return `${m}m ago`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h}h ago`;
  return `${Math.floor(h / 24)}d ago`;
}

export default function NotificationBell() {
  const [open, setOpen] = useState(false);
  const [notifs, setNotifs] = useState([]);
  const [unread, setUnread] = useState(0);
  const ref = useRef();

  const load = useCallback(async () => {
    try {
      const { data } = await api.get('/notifications/list.php');
      if (data.success) { setNotifs(data.data); setUnread(data.unread); }
    } catch {}
  }, []);

  useEffect(() => { load(); const t = setInterval(load, 30000); return () => clearInterval(t); }, [load]);

  useEffect(() => {
    const h = e => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', h);
    return () => document.removeEventListener('mousedown', h);
  }, []);

  const markAll = async () => {
    await api.post('/notifications/mark.php', { action: 'mark_read', id: 'all' });
    load();
  };
  const markOne = async id => {
    await api.post('/notifications/mark.php', { action: 'mark_read', id });
    load();
  };

  return (
    <div ref={ref} style={{ position:'relative' }}>
      <button onClick={() => { setOpen(!open); if (!open) load(); }}
        style={{ position:'relative', width:36, height:36, display:'flex', alignItems:'center', justifyContent:'center', background:'rgba(255,255,255,.1)', border:'none', borderRadius:8, cursor:'pointer', color:'rgba(255,255,255,.8)', fontSize:18 }}>
        🔔
        {unread > 0 && (
          <span style={{ position:'absolute', top:-2, right:-2, minWidth:16, height:16, background:'#ef4444', color:'#fff', fontSize:10, fontWeight:700, borderRadius:8, display:'flex', alignItems:'center', justifyContent:'center', padding:'0 3px' }}>
            {unread > 9 ? '9+' : unread}
          </span>
        )}
      </button>

      {open && (
        <div style={{ position:'fixed', top:60, left:16, width:300, background:'#fff', borderRadius:12, boxShadow:'0 8px 30px rgba(0,0,0,.15)', border:'1px solid var(--border)', zIndex:999, overflow:'hidden' }}>
          <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', padding:'12px 16px', borderBottom:'1px solid var(--border)' }}>
            <strong style={{ fontSize:13 }}>Notifications</strong>
            <div style={{ display:'flex', gap:10, alignItems:'center' }}>
              {unread > 0 && <button onClick={markAll} style={{ fontSize:11, color:'var(--teal)', background:'none', border:'none', cursor:'pointer', fontWeight:600 }}>Mark all read</button>}
              <button onClick={() => setOpen(false)} style={{ background:'none', border:'none', cursor:'pointer', fontSize:16, color:'var(--text2)' }}>✕</button>
            </div>
          </div>
          <div style={{ maxHeight:'60vh', overflowY:'auto' }}>
            {notifs.length === 0
              ? <div style={{ padding:'30px 16px', textAlign:'center', color:'var(--text2)', fontSize:13 }}>No notifications</div>
              : notifs.map(n => (
                <div key={n.id} onClick={() => markOne(n.id)}
                  style={{ display:'flex', gap:10, padding:'10px 14px', borderBottom:'1px solid #f8fafc', cursor:'pointer', background: n.is_read ? 'transparent' : '#f0fdf4', opacity: n.is_read ? 0.7 : 1 }}>
                  <div style={{ width:8, height:8, borderRadius:'50%', background: n.is_read ? 'transparent' : 'var(--teal)', flexShrink:0, marginTop:5 }} />
                  <div style={{ flex:1 }}>
                    <div style={{ fontSize:12, color:'var(--text)', lineHeight:1.5 }}>{n.message}</div>
                    <div style={{ fontSize:10, color:'var(--text2)', marginTop:3 }}>{timeAgo(n.created_at)}</div>
                  </div>
                </div>
              ))
            }
          </div>
        </div>
      )}
    </div>
  );
}
